<template>
  <b-sidebar
    id="sidebar-filter"
    aria-label="Sidebar with custom filter"
    backdrop
    bg-variant="white"
    v-model="showSideBar"
    class="sidebar-filter"
  >
    <template #header>
      <div class="sidebar-filter__header">
        فرز وترتيب الخدمات بحسب
        <div class="sidebar-filter__header__icons">
          <inline-svg
            :src="require(`@/assets/images/icons/dashboard/filter-2.svg`)"
          />
          <inline-svg
            :src="require(`@/assets/images/icons/dashboard/swap.svg`)"
          />
        </div>
      </div>
    </template>
    <div class="px-1 py-2">
      <div
        class="sidebar-filter__box"
        v-for="category in 4"
        :key="`list-${category}`"
      >
        <div
          class="sidebar-filter__box__header"
          v-b-toggle="`list-${category}`"
        >
          <span class="sidebar-filter__box__header__title"
            >اسم التصنيف #{{ category }}</span
          >
          <span>{{ category + 5 }}</span>
        </div>
        <b-collapse :id="`list-${category}`" :visible="category === 1">
          <ul class="sidebar-filter__box__list">
            <li class="sidebar-filter__box__list__item" v-for="i in 3" :key="i">
              <b-form-checkbox value="A">اختيار رقم #{{ i }}</b-form-checkbox>
              <span>{{ i + 2 }}</span>
            </li>
          </ul>
        </b-collapse>
      </div>
    </div>

    <template #footer="{ hide }">
      <div class="d-flex px-1 py-1 border-top">
        <button class="col py-1 btn btn--light-green" @click="hide">
          إزالة الاختيارات
        </button>
        <button class="col py-1 btn btn--gradient-green ml-1" @click="hide">
          عرض النتائج
        </button>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { BSidebar, BFormCheckbox, BCollapse, VBToggle } from "bootstrap-vue";
export default {
  name: "SideBarFilter",
  directives: {
    "b-toggle": VBToggle,
  },
  components: {
    BSidebar,
    BFormCheckbox,
    BCollapse,
  },
  data() {
    return {
      showSideBar: false,
    };
  },
};
</script>
